class TableHelper {
  static definirFiltrosDinamicos(params, filters, possibleKeys) {
    Object.keys(filters).forEach(key => {
      if (filters[key] && possibleKeys.includes(key)) {
        params[key] = filters[key];
      }
    });

    return params;
  }

  static definirOrdenacao(params, sorter) {
    const order = sorter.order === 'ascend' ? 'ASC' : 'DESC';

    params.orderBy = order;
    params.sortBy = sorter.columnKey;

    return params;
  }
}

export default TableHelper;
